export const serviceAttach = {
    commissionPrice:{ name:"加赏任务佣金，每单"},
    wangTagChecked:{
        name:"旺旺本品打标",
        wangTagSelected:{
            0:"首次接单买手打标",
            1:"每次接单买手打标"
        }
    },
    breviewChecked:{name:"商家自主审核买号"},
    autoVerifyNumChecked:{
        name:"自动验号",
        customeVerifyReview:{
            0:"首次接单买手验号",
            1:"每次接单买手验号"
        }
    },
    verifyGoodLinkChecked:{ name:"核对商品链接"},
    accountLimitChecked:{
        name:"账号等级限制",
        accountLimitLever:{
            0:"低于3心无法接单",
            1:"低于4心无法接单",
            2:"低于5心无法接单",
            3:"低于1钻无法接单"
        }
    },
    taoLimitChecked:{
        name:"淘气值限制",
        taoLimitLever:{
            0:"低于400无法接单",
            1:"低于650无法接单",
            2:"低于800无法接单",
            3:"低于1000无法接单"
        }
    },
    browserGoodChecked:{
        name:"浏览副宝贝",
        browserGoodReview:{
            0:"无需截图",
            1:"需要截图"
        }
    },
    addCardChecked:{
        name:"加入购物车",
        addCardReview:{
            0:"无需截图",
            1:"需要截图"
        }
    },
    limitDateChecked:{name:"七天内完成过浏览单"},
    videoMutualChecked:{name:"直播互动留言"},
    customerBrowserTimeChecked:{
        name:"设定买家的浏览时间",
        cbrowserTimeLever:{
            0:"1分钟",
            1:"2分钟",
            2:"3分钟",
            3:"4分钟",
            4:"5分钟",
            5:"6分钟",
            6:"7分钟",
            7:"8分钟",
            8:"9分钟",
            9:"10分钟"
        }
    },
    realyPersonFlowChecked:{
        name:"淘宝真实人工流量",
        realyPersonFlowLever:{
            0:"1流量",
            1:"2流量",
            2:"3流量",
            3:"4流量",
            4:"5流量",
            5:"10流量",
            6:"15流量",
            7:"20流量"
        }
    },
    isCanUsePackgeChecked:{name:"允许使用优惠券及红包"},
    isCanUseCartChecked:{name:"允许使用信用卡"},
    isCanUseAlipayChecked:{name:"允许使用花呗"},
    browserTargetGoodChecked:{
        name:"浏览目标宝贝",
        browserTargetGoodReview:{
            0:"无需截图",
            1:"需要截图"
        }
    },
    needToTalkChecked:{
        name:"需要假聊",
        needToTalkReview:{
            0:"无需截图",
            1:"需要截图"
        }
    },
    collectShopChecked:{
        name:"收藏店铺",
        collectShopReview:{
            0:"无需截图",
            1:"需要截图"
        }
    },
    collectGoodChecked:{
        name:"收藏宝贝",
        collectGoodReview:{
            0:"无需截图",
            1:"需要截图"
        }
    },
    localLimitChecked:{
        name:"地域限制",
        localLimitReview:{
            0:"可接单",
            1:"不可接单"
        },
        localInfosChecked:"地域数组"
    },
    ageLimitChecked:{
        name:"年龄限制",
        ageLimitReview:{
            0:"18-25",
            1:"26-35",
            2:"35以上"
        }
    },
    sexLimitChecked:{
        name:"性别限制",
        sexLimitReview:{
            0:"女",
            1:"男"
        }
    },
    compareGoodChecked:{
        name:"货比足迹",
        compareGoodReview:{
            0:"无需截图",
            1:"需要截图"
        }
    },
    verifyCodeChecked: {
        name:"核验码",
    }
}
